import { render, staticRenderFns } from "./EpisodeCard.vue?vue&type=template&id=34e57760&scoped=true&"
import script from "./EpisodeCard.vue?vue&type=script&lang=js&"
export * from "./EpisodeCard.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeCard.vue?vue&type=style&index=0&id=34e57760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e57760",
  null
  
)

export default component.exports